import React, { useState } from 'react';
import { cx } from './utils';

export default function Logo({ className }) {
  // Placeholder: if you add /public/logo.svg it will be used automatically.
  // Otherwise we render a clean text mark.
  const logoSrc = '/logo.svg';
  const [hasLogo, setHasLogo] = useState(true);

  return (
    <div className={cx('brand', className)}>
      {hasLogo ? (
        <img
          className="brand__logo"
          src={logoSrc}
          alt="Premtech"
          onLoad={() => setHasLogo(true)}
          onError={() => setHasLogo(false)}
        />
      ) : null}

      {!hasLogo ? (
        <div className="brand__text">
          <div className="brand__name">Premtech</div>
          <div className="brand__tag">Productcatalogus</div>
        </div>
      ) : null}
    </div>
  );
}
